import { render, staticRenderFns } from "./myprofile.vue?vue&type=template&id=df160fe6&"
import script from "./myprofile.vue?vue&type=script&lang=js&"
export * from "./myprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports